import { graphql } from 'react-relay';

export const SubscriptionPlansQuery = graphql`
  query SubscriptionPlansQuery {
    subscriptionPlans {
      slug
      name
      valueCents
      comingSoon
    }
    activePaymentProvider
    viewer {
      subscription {
        id
        plan
        status
        valueCents
        autoChargeExcess
        cancelledAt
        createdAt
      }
      savedCards {
        id
        creditCardBrand
        creditCardNumber
        holderName
        isPrimary
        createdAt
      }
    }
  }
`;
